import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Collapse, Card } from "react-bootstrap";

import SdIn from "./sd_in";
import SdTitle from "./sd_title";
import PtIn from "./pt_in";
import PtTitle from "./pt_title";
import ClassesIn from "./classes_in";
import ClassesHeader from "./classes_header";
import CoursesIn from "./courses_in";
import CoursesTitle from "./courses_title";

const Home_Features = () => {
  const [openCl, setOpenCl] = useState(false);
  const [textCl, setTextCl] = useState("More");
  function handleCl() {
    setOpenCl(!openCl);
    if (!openCl ? setTextCl("Less") : setTextCl("More"));
  }

  const [openSd, setOpenSd] = useState(false);
  const [textSd, setTextSd] = useState("More");
  function handleSd() {
    setOpenSd(!openSd);
    if (!openSd ? setTextSd("Less") : setTextSd("More"));
  }

  const [openPt, setOpenPt] = useState(false);
  const [textPt, setTextPt] = useState("More");
  function handlePt() {
    setOpenPt(!openPt);
    if (!openPt ? setTextPt("Less") : setTextPt("More"));
  }

  const [openCo, setOpenCo] = useState(false);
  const [textCo, setTextCo] = useState("More");
  function handleCo() {
    setOpenCo(!openCo);
    if (!openCo ? setTextCo("Less") : setTextCo("More"));
  }

  function scrollToSection(id) {
    const element = document.getElementById(id);
    const headerOffset = 80;

    const y =
      element.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    if (id === "CL") {
      setOpenCl(false);
      setTextCl("More");
    }
    if (id === "SD") {
      setOpenSd(false);
      setTextSd("More");
    }

    if (id === "PT") {
      setOpenPt(false);
      setTextPt("More");
    }

    if (id === "CO") {
      setOpenCo(false);
      setTextCo("More");
    }

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }

  const ClassesInfo = ({ Id }) => {
    return (
      <>
        <div className="col-md-3 text-center" id={Id}>
          <h3 className="fw-bold">Classes</h3>
          <img
            src="./img/London-Kickboxing-red-1.white.png"
            alt="kickboxing"
            className="img-fluid rounded"
            width="80px"
          />
          <br />
          <Link
            to="#classes"
            className="btn btn-danger"
            onClick={() => handleCl()}
          >
            <i>Read {textCl}</i>
          </Link>
          <br />
          <br />
        </div>
        <Collapse in={openCl}>
          <Card className="mt-3 retrobg">
            <Card.Body>
              <ClassesHeader />
              <div className="text-left">
                <ClassesIn />
              </div>
              <Link
                to="#"
                className="btn btn-link"
                onClick={() => scrollToSection(Id)}
              >
                <i>Close</i>
              </Link>
            </Card.Body>
          </Card>
        </Collapse>
      </>
    );
  };

  const SdInfo = ({ Id }) => {
    return (
      <>
        <div className="col-md-3 text-center" id={Id}>
          <h3 className="fw-bold">Self Defence</h3>
          <img
            src="./img/London-Kickboxing-red-1.white.png"
            alt="kickboxing"
            className="img-fluid rounded"
            width="80px"
          />
          <br />          
          <Link to="#Sd" className="btn btn-danger" onClick={() => handleSd()}>
            <i>Read {textSd}</i>
          </Link>
          <br />
          <br />
        </div>
        <Collapse in={openSd}>
          <Card className="mt-3 retrobg">
            <Card.Body>
              <SdTitle />
              <div className="text-left">
                <SdIn />
              </div>
              <Link
                to="#"
                className="btn btn-link"
                onClick={() => scrollToSection(Id)}
              >
                <i>Close</i>
              </Link>
            </Card.Body>
          </Card>
        </Collapse>
      </>
    );
  };

  const PtInfo = ({ Id }) => {
    return (
      <>
        <div className="col-md-3 text-center" id={Id}>
          <h3 className="fw-bold">Personal Training</h3>
          <img
            src="./img/London-Kickboxing-red-1.white.png"
            alt="kickboxing"
            className="img-fluid rounded"
            width="80px"
          />
          <br />
          <Link to="#Pt" className="btn btn-danger" onClick={() => handlePt()}>
            <i>Read {textPt}</i>
          </Link>
          <br />
          <br />
        </div>
        <Collapse in={openPt}>
          <Card className="mt-3 retrobg">
            <Card.Body>
              <PtTitle />
              <div className="text-left">
                <PtIn />
              </div>
              <Link
                to="#"
                className="btn btn-link"
                onClick={() => scrollToSection(Id)}
              >
                <i>Close</i>
              </Link>
            </Card.Body>
          </Card>
        </Collapse>
      </>
    );
  };

  const CoursesInfo = ({ Id }) => {
    return (
      <>
        <div className="col-md-3 text-center" id={Id}>
          <h3 className="fw-bold">Courses</h3>
          <img
            src="./img/London-Kickboxing-red-1.white.png"
            alt="kickboxing"
            className="img-fluid rounded"
            width="80px"
          />
          <br />
          <Link to="#co" className="btn btn-danger" onClick={() => handleCo()}>
            <i>Read {textCo}</i>
          </Link>
          <br />
          <br />
        </div>
        <Collapse in={openCo}>
          <Card className="mt-3 retrobg">
            <Card.Body>
              <CoursesTitle />
              <div className="text-left">
                <CoursesIn />
              </div>
              <Link
                to="#"
                className="btn btn-link"
                onClick={() => scrollToSection(Id)}
              >
                <i>Close</i>
              </Link>
            </Card.Body>
          </Card>
        </Collapse>
      </>
    );
  };

  return (
    <section className="retrobg container text-left py-4 border-top border-secondary">
      <div className="row">
        <ClassesInfo Id="CL" />
        <SdInfo Id="SD" />
        <PtInfo Id="PT" />
        <CoursesInfo Id="CO" />
      </div>
    </section>
  );
};

export default Home_Features;
